import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { ResponsiveContext } from '@/context/ResponsiveContext';

// Create a provider component
export const ResponsiveProvider = ({ children }: { children: React.ReactNode }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTablet = useMediaQuery({ query: '(min-width: 601px) and (max-width: 1024px)' });
    //const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });

    const currentMode = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
    return (
        <ResponsiveContext.Provider value={{ currentMode }}>{children}</ResponsiveContext.Provider>
    );
};

// Custom hook to use the ResponsiveContext
//export const useResponsive = () => {
//  return useContext(ResponsiveContext);
//};
